import { Navbar, NavbarHome, Main, Product, Footer } from "../components";
import { useSelector } from 'react-redux';
import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';

function Header() {

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };


    return (
        <>
            <nav>
                <Link to='/' className="nav-brand" href="#">
                    Dreams From Our Founding Fathers
                </Link>
                <span className="nav-limited">
                    Limited to 1776 Signed & Numbered Copies
                </span>
                <div>
                    <Link to='/order-track' className="track_order_link">
                        Track Order
                    </Link>
                    <Link
                        to="#"
                        className="nav-btn disabled-site-action"
                        aria-disabled="true"
                        onClick={(e) => e.preventDefault()}
                    >
                        SOLD OUT
                    </Link>
                </div>
            </nav>
        </>
    )

}
export default Header
